import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/summary/list", {
    sort: "created,desc",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/summary/list", {
    output: "csv",
    ...params,
  });
};
